import * as React from 'react';

import { Autocomplete, AutocompleteProps } from '@emburse/ui-core';

import { IUserExtension } from '@ClientModels/userExtension';

interface IEmployeeSelectProps extends Omit<AutocompleteProps<string>, 'children'> {
  selectedValue?: IUserExtension;
  userOptions: IUserExtension[];
}

export const EmployeeSelect: React.FC<IEmployeeSelectProps> = ({ userOptions, selectedValue = '', ...rest }) => (
  <Autocomplete
    getOptionLabel={(option: IUserExtension) => option.displayName || ''}
    isOptionEqualToValue={(option: IUserExtension, val: string) => {
      return option.id === val;
    }}
    options={userOptions}
    value={selectedValue}
    {...rest}
  />
);
